import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AudioData } from 'src/app/models/audioModel/audio-data.model';
import { AudioPlayerPortalService } from './audio-player-portal.service';

@Component({
  selector: 'app-audio-player-portal',
  templateUrl: './audio-player-portal.component.html',
  styleUrls: ['./audio-player-portal.component.scss']
})
export class AudioPlayerPortalComponent implements OnInit, OnDestroy {
  private subscriptions = new Subscription();
  
  public audioDataList: AudioData[] = [];

  positionFixed = false;

  constructor(
    private audioPlayerPortalService: AudioPlayerPortalService,
    private router: Router
    ) { }

  @HostListener('window:scroll')
  onScroll() {
    const verticalScroll = window.scrollY;    
    if (verticalScroll > 85) {
      this.positionFixed = true;
    } else {
      this.positionFixed = false;
    }
  }

  ngOnInit(): void {
    this.listenForAudioPlayer();
    this.listenForRouteChanges();
  }

  listenForAudioPlayer(): void {
    const subscription = this.audioPlayerPortalService.currentPlayer$.subscribe((audioData) => {      
      if(!audioData) { return; }
      //if (this.findAudioList(audioData)){
        if(audioData.link != '') {
          this.deleteReproductor(audioData);
        }
        this.audioDataList.push(audioData)
     // }
    });
    this.subscriptions.add(subscription);
  }

  findAudioList(data: AudioData){
    const index = this.audioDataList.findIndex((row => row.title === data.title));
    if(index < 0){
      return false;
    }
    return true;
  }

  listenForRouteChanges(): void {
    const subscription = this.router.events.subscribe((event) => {
      if(event instanceof NavigationEnd) {
        if(event.url.includes('edit/')) {
          this.deletePlayers();
        }
        if(event.url.includes('/')){
          this.deletePlayers();
        }
      }
    });
    this.subscriptions.add(subscription);
  }

  public deleteReproductor(audioData){
    const index = this.audioDataList.findIndex((row) => row === audioData);
    this.audioDataList.splice(index, 1);
  }

  private deletePlayers() {
    this.audioDataList = [];
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
